<app-loading-screen></app-loading-screen>  
<router-outlet></router-outlet>
<!-- <app-chat></app-chat> -->